export default function ({ store, error }) {
  if(store.state.auth.user == null){
    return error({statusCode: 401, message: 'Нет доступа. Необходимо авторизоваться'})
  }
}